// src/components/common/PageHeader/PageHeader.jsx
import React from 'react';
import styles from './PageHeader.module.css';

const PageHeader = ({
    title,
    actionText,
    onAction,
    disabled = false,
    showAction = true,
}) => {
    return (
        <div className={styles.header}>
            <div className={styles.titleSection}>
                <h1>{title}</h1>
            </div>
            {showAction && actionText && (
                <button
                    onClick={onAction}
                    className={styles.addButton}
                    disabled={disabled}
                >
                    + {actionText}
                </button>
            )}
        </div>
    );
};

export default PageHeader;